import React from 'react';
import { Clock3, Package, MapPin, ShieldCheck, FileText } from 'lucide-react';
import { DownloadButton } from '../ui';

export const ProductMedia = ({ product }) => <div>
  <div className="detail-image">
    {product.image_url ? <img src={product.image_url} alt={product.name} /> : <Package size={80} />}
    {product.demo && <span data-testid="product-demo-badge">Demonstration product · Representative image</span>}
  </div>
  <div className="detail-documents">
    <h2><FileText size={19} />Technical documents</h2>
    <DownloadButton path={`/products/${product.id}/specification`} name={`${product.sku}-specification.txt`}
      id="download-specification">Product specification · TXT</DownloadButton>
    {product.documents?.map(file => <DownloadButton key={file.id} path={`/files/${file.id}`}
      name={file.name} id={`download-document-${file.id}`}>{file.name}</DownloadButton>)}
    <p>Supplier-provided specifications are not compliance certificates.</p>
  </div>
</div>;

export const ProductInfo = ({ product }) => <>
  <div className="eyebrow">{product.category.replaceAll('-', ' ')} / {product.industry}</div>
  <h1 data-testid="product-detail-name">{product.name}</h1>
  <div className="detail-codes"><span data-testid="product-detail-sku">SKU {product.sku}</span>
    <span data-testid="product-detail-hsn">HSN / SAC {product.hsn}</span></div>
  <p className="detail-description">{product.description}</p>
  <div className="supplier-detail">
    <span className="supplier-avatar">{product.supplier_name[0]}</span>
    <div><strong data-testid="product-detail-supplier">{product.supplier_name}</strong>
      <span><MapPin size={12} />{product.supplier_city}, India {product.demo && '· Demo supplier'}</span></div>
  </div>
  <div className="detail-facts">
    <span><Package size={18} /><small>Minimum order</small><strong data-testid="product-detail-moq">{product.moq} {product.unit}</strong></span>
    <span><Clock3 size={18} /><small>Lead time</small><strong data-testid="product-detail-lead">{product.lead_days} days</strong></span>
    <span><ShieldCheck size={18} /><small>Packaging</small><strong data-testid="product-detail-packaging">{product.packaging}</strong></span>
  </div>
</>;

export const ProductSpecifications = ({ product }) => <section className="spec-section">
  <div><span className="eyebrow">THE DETAILS THAT MATTER</span><h2>Technical specifications</h2></div>
  <dl>{Object.entries({ Grade: product.grade, 'Reference standard': product.standard, ...product.specs })
    .map(([name, value]) => <div key={name}><dt>{name}</dt><dd>{value}</dd></div>)}</dl>
</section>;